module.exports = __webpack_public_path__ + "img/mh_logo.8df841b3.jpg";